import styled from "styled-components"

export default styled.h2`
  padding: 35px 5px 29px;
  font-size: 1.9em;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 0;
`
